import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// buefy
import Buefy from 'buefy'
Vue.use(Buefy)

// ui-library
import * as UILibrary from '@vigilantapps/ui-library'
Vue.use(UILibrary)

// local services
import CommonRegister from './components/common/register'
import titleMixin from './services/browser/title'
Vue.mixin(titleMixin)
CommonRegister(Vue)

// scss imports
import "animate.css"
import "./styles/Main.scss"

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import * as fas from '@fortawesome/free-solid-svg-icons'
import * as fab from '@fortawesome/free-brands-svg-icons'
import { faMessageDots, faMessageSms } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
library.add(
  // duotone
  faMessageDots, // samsung
  faMessageSms, // mms/sms
  // other
  fas.faShieldVirus, // navbar
  fab.faMicroblog, // navbar
  fas.faBell, // default notification icon
  fas.faSplotch, // provisioning / bootstrapper / startup / setup
  fas.faAngleRight, // next page
  fas.faAngleLeft, // previous page
  fas.faEllipsisV, // filters menu
  fas.faSearch, // search
  fas.faScrewdriver, // property / properties
  fas.faHammer, // rule / rules
  fas.faBook, // keywords / swearing
  fab.faMicrosoft, // microsoft / office
  fas.faBoxOpen, // software / install
  fab.faUsb, // usb / pluggable devices / keyfobs / dongles / peripherals
  fas.faUsersViewfinder, // target policy / targeted individuals
  fas.faFileVideo, // apple live photo
  fas.faFileAudio, // audio recording
  fas.faPaperclip, // attachments menu for notification
  fas.faPlusCircle, // filters date scope
  fas.faTag, // group / groups / grouping
  fas.faAtom, // policy set / policies
  fab.faAppStore, // mobile app variation
  fab.faAndroid, // mobile device / android
  fab.faWindows, // laptop / windows device / computer
  fas.faChevronDown, // load more
  fas.faChevronUp, // back to latest
  fab.faWhatsapp, // whatsapp
  fas.faShare, // message forwarded
  fas.faCommentSms, // sms messenger
  fab.faWeixin, // wechat
  fas.faComment, // unknown IM channel
  fas.faComments, // conversation snapshot button
  fas.faPhoneFlip, // phone / telephony / calls / calling
  fas.faPhoneSlash, // call ended / call blocked
  fas.faLock, // sessions / user log-on log-off
  fas.faEye, // view notification
  fas.faBox, // agent / end device / monitored / unknown device type
  fas.faLanguage, // swearing / keywords / racial / keyword monitoring
  fas.faClone, // copy / copy notification link / copy link / duplicate / clone
  fas.faSquareArrowUpRight, // open in new window
  fas.faMessage, // samsung messenger
  fas.faSliders, // edit / settings / configuration
  fas.faBullhorn, // im broadcast event / multicast / anycast
  fas.faChartColumn, // trends / aggregations / charts / analysis
  fas.faSignal, // wifi / connectivity change
  fas.faImage, // screenshot / image / photo
  fab.faSlack, // slack / slackInteractions
  fas.faKeyboard, // keyboard / hotkey / shortcut
  fas.faWindowRestore, // window focus changed / process changed
  fas.faFolderOpen, // open attempts
  fas.faPrint, // print attempts / printer
  fab.faSafari, // browser / BrowserEvent
  fas.faArrowPointer, // user click / mouse / button clicked
  fas.faDragon, // reaction policy
  fas.faRobot, // behaviour monitor
  fas.faDoorOpen, // welcome / started / begun
  fas.faClock, // time related / from / timestamp
  fas.faGear, // windows service
  fas.faCircleInfo, // info / context / im system message
  fas.faPlus, // add / new
  fas.faTrashCan, // delete / remove
  fab.faBluetooth, // bluetooth hardware events
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')